/** Тип словаря: каждая строка хранит оба языка рядом, чтобы перевод не отставал от оригинала. */
export type Lang = 'ru' | 'en';

/** Формы множественного числа по Intl.PluralRules; `other` обязательна. */
export type Plural = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };

export interface Entry {
  ru: string | Plural;
  en: string | Plural;
}

export function defineMessages<T extends Record<string, Entry>>(messages: T): T {
  return messages;
}
